import React, { FC, memo } from 'react';
import BiTextDialog from '../dialogs/bi-text-dialog/bi-text-dialog';
import { localized } from 'state/i18n';
import BiButton from '../buttons/bi-button/bi-button';
interface Props {
	onHide: () => void;
	visible: boolean;
	onOk: () => void;
    title: string;
}

export const NoSubscriptionDialog: FC<Props> = memo(props => {
	const { onHide, onOk, visible, title } = props;
	return (
		<BiTextDialog onHide={onHide} visible={visible} title={title}>
			<div className="">{localized('BuyMachineSubscriptionForNotification')}</div>
			<div className="flex-center-row margin-top-10px">
				<BiButton colorTheme="org-primary" containerTheme="normal-button-corners" onClick={onOk}>
					{localized('Ok')}
				</BiButton>
			</div>
		</BiTextDialog>
	);
});
